module.exports = __webpack_public_path__ + "img/gaiaformer.77e7f7f7.svg";